import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { NbAuthModule, NbDummyAuthStrategy } from "@nebular/auth";
import { NbSecurityModule, NbRoleProvider } from "@nebular/security";
import { of as observableOf } from "rxjs";

import { throwIfAlreadyLoaded } from "./module-import-guard";


/**
 * Minimal Nebular role provider that reports every user as the `guest` role.
 * Placeholder for a future role-based access control integration; the app's
 * real authorization is enforced by Auth0 and the backend permission system.
 */
export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf("guest");
  }
}

/**
 * Root-level providers for the core module: Nebular auth/security scaffolding
 * and the {@link NbSimpleRoleProvider} role provider registration.
 */
export const NB_CORE_PROVIDERS = [
  ...NbAuthModule.forRoot({
    strategies: [],
    forms: {},
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: "*",
      },
      user: {
        parent: "guest",
        create: "*",
        edit: "*",
        remove: "*",
      },
    },
  }).providers,

  {
    provide: NbRoleProvider,
    useClass: NbSimpleRoleProvider,
  },
];

@NgModule({
  imports: [CommonModule],
  exports: [NbAuthModule],
  declarations: [],
})
/** Core module providing app-wide Nebular auth/security setup; must only be imported once (guarded via {@link throwIfAlreadyLoaded}). */
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }

  /** Registers the core providers (Nebular auth, security, role provider) at the application root. */
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
